'use strict'
import {Dispatcher} from 'flux';

export default new Dispatcher();


/** WEBPACK FOOTER **
 ** ./src/core/appDispatcher.js
 **/